<div class="side-menu-container">
  <div class="menu-header"><b>My profile</b></div>
  <app-menu-item id="my-profile" title="My profile" linkTo="user/profile"></app-menu-item>

  @if (!isLimitedAccess) {
    <div class="menu-header"><b>Organizer</b></div>
    <app-menu-item id="organizer-profile" title="Organizer profile" linkTo="organizers/profile"></app-menu-item>
    <app-menu-item id="setllement-account" title="Settlement Accounts" linkTo="organizers/accounts"></app-menu-item>
    <app-menu-item id="view-profile" title="View Organizers" linkTo="organizers"></app-menu-item>
    <app-menu-item
      id="switch-profile"
      title="Switch Organizers"
      linkTo="organizers/switch"
      params="{'switch': true}"></app-menu-item>
    <app-menu-item id="user-consents" title="User consents" linkTo="consents"></app-menu-item>
    <app-menu-item id="invoice" title="Invoice report" linkTo="invoices/report"></app-menu-item>

    <app-menu-item id="credits" title="Credits" linkTo="credits"></app-menu-item>
  }

  <div class="menu-header"><b>Events</b></div>
  <app-menu-item id="events" title="Events" linkTo="events"></app-menu-item>
  <app-menu-item id="create-new-event" title="Create new event" linkTo="events/new"></app-menu-item>

  @if (!isLimitedAccess) {
    <app-menu-item id="create-new-organizer" title="Create new organizer" linkTo="organizers/create"></app-menu-item>

    <app-menu-item id="event-user-consents" title="User consents" linkTo="consents"></app-menu-item>

    <app-menu-item id="instructors" title="Instructors" linkTo="instructors"></app-menu-item>

    <app-menu-item id="tags" title="Tags" linkTo="tags"></app-menu-item>

    <app-menu-item id="venues" title="Venues" linkTo="venues"></app-menu-item>

    <app-menu-item id="types" title="Types" linkTo="types"></app-menu-item>

    <app-menu-item id="levels" title="Levels" linkTo="levels"></app-menu-item>

    <app-menu-item id="discounts" title="Discounts" linkTo="discounts"></app-menu-item>

    <app-menu-item id="reporting" title="Reporting" linkTo="reporting"></app-menu-item>
  }

  <div class="menu-header"><b>Bookings</b></div>
  <app-menu-item id="create-new-booking" title="Create new booking" linkTo="booking-events/new"></app-menu-item>
  <app-menu-item id="bookings" title="Events" linkTo="booking-events/list"></app-menu-item>
  <app-menu-item id="booking-report" title="Booking report" linkTo="booking-report"></app-menu-item>

  @if (!isLimitedAccess) {
    <div class="menu-header"><b>Reports</b></div>
    <app-menu-item id="free-taster" title="Free Taster" linkTo="reports/freetaster"></app-menu-item>
  }
</div>
